var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDouglasIconsProfileNeutral(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45 45",
    style: {
      enableBackground: "new 0 0 45 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#FF00FF;}\n\t.st3{display:inline;fill:none;stroke:#FF00FF;stroke-width:0.025;stroke-miterlimit:10;}\n\t.st4{fill:#00FF00;}\n\t.st5{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:square;}\n\t.st6{clip-path:url(#SVGID_2_);}\n\t.st7{clip-path:url(#SVGID_4_);}\n\t.st8{clip-path:url(#SVGID_6_);}\n\t.st9{clip-path:url(#SVGID_8_);}\n\t.st10{clip-path:url(#SVGID_10_);enable-background:new    ;}\n\t.st11{clip-path:url(#SVGID_12_);}\n\t.st12{clip-path:url(#SVGID_14_);}\n\t.st13{clip-path:url(#SVGID_16_);}\n\t.st14{clip-path:url(#SVGID_18_);}\n\t.st15{clip-path:url(#SVGID_20_);}\n\t.st16{clip-path:url(#SVGID_22_);}\n\t.st17{clip-path:url(#SVGID_24_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GRID_x21_",
    className: "st0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Punkte_Sammeln"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Kostenloser_Versand"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_2_"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Lieferung"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_4_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_3_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_2_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_10_"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Merkzettel"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_2_8_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_9_"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Warenkorb"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_11_"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Beautycard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_2_6_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.64746,30.02246l-0.1568-0.04877l-0.58636-0.40875c-0.08008-0.05615-1.97656-1.41748-2.66992-5.15479l-0.00806-0.04346 C30.20007,21.61694,32,16.69873,32,11.98389C31.88672,5.0127,27.75879-0.00098,22.16016-0.00098 c-0.04102,0-0.08301,0.00049-0.125,0.00098c-3.08496-0.07959-6.09082,1.17773-7.98242,3.32861 c-1.9043,2.16406-2.9834,5.24268-3.03906,8.68506c0,4.26068,2.05609,9.08099,5.15118,11.96686l0.27948,0.66595 c0.04004,0.09619,0.94336,2.38916-3.19141,4.88818l-0.66602,0.37354l-0.29688,0.13818C11.86914,30.24121,2,34.88379,2,40.5V45h1 v-4.5c0-4.4873,7.80566-8.60205,9.4209-9.40576c8.34766,7.15234,16.72559,1.12646,18.1875-0.03662 C42.00977,34.65137,42.00195,39.04736,42,40.5V45h1v-4.49902C43.00684,36.0249,38.9668,32.59717,30.64746,30.02246z  M13.01367,12.02979c0.04785-2.95117,0.9502-5.57227,2.54102-7.37988c1.46875-1.66992,3.79004-2.65234,6.24316-2.65234 c0.07031,0,0.14062,0.00049,0.21094,0.00195L22.04688,2c0.03906-0.00049,0.07715-0.00098,0.11523-0.00098 C26.6875,1.99902,29.9043,6.09863,30,12c0,5.93311-3.41504,12.56885-7.98438,12.56885 C17.16797,24.56885,13.01367,17.66504,13.01367,12.02979z M14.26819,31.25861l0.0199-0.01202 c3.31348-2.00305,4.14886-4.10846,4.25104-5.56732c1.0929,0.56091,2.25922,0.88959,3.4765,0.88959 c1.24103,0,2.39117-0.34015,3.44446-0.9187c0.9126,3.64642,2.86627,5.23669,3.25629,5.52277 C26.09363,32.8313,20.27557,35.46753,14.26819,31.25861z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_7_"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Magazin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_6_"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Special"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_5_"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Gratis_Probe"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_4_"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Einladung"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_2_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_3_"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Geschenk"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_2_9_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_12_"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Bezahlen"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Umtausch"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_1_"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Rabatt"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_13_"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Drucker"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Kalender"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Social_Media_1_"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDouglasIconsProfileNeutral);
export default __webpack_public_path__ + "static/media/Douglas_Icons_Profile_Neutral.51ff2b66.svg";
export { ForwardRef as ReactComponent };